module.exports = __webpack_public_path__ + "media/images/icon_x32-35558f80634446f327228f1484515a23.png";